import axios from 'axios';

/* const TWO_WEEKS = 1209600000; 
const FIVE_SEC = 1000 * 5;  */
const FIVE_DAYS = 432000000; 

// Время кэширования менять тут
const CHACHE_TIME = FIVE_DAYS;

// Вспомогательная функция только для режима с ошибками
function loadErrorsTickets(categoryTickets, GlobalTicketsArr) {
  let errorsArray = JSON.parse(localStorage.getItem("errorsArray"));
  if (errorsArray === null) return [];

  const lSErrorTicket = JSON.parse(localStorage.getItem("errorsArray")).filter(
    (ticket) =>
      ticket.ticketCategory.slice(
        ticket.ticketCategory.length - 2,
        ticket.ticketCategory.length
      ) ===
      categoryTickets.slice(
        categoryTickets.length - 2,
        categoryTickets.length
      ) && ticket.ticketErrors.length !== 0
  );

  let GlobalTicketsArray;

  /*   if (categoryTickets === "errorsAB") GlobalTicketsArray = TICKETS;
    else if (categoryTickets === "errorsCD") GlobalTicketsArray = TICKETS_CD; */
  if (categoryTickets === "errorsAB") GlobalTicketsArray = GlobalTicketsArr;
  else if (categoryTickets === "errorsCD") GlobalTicketsArray = GlobalTicketsArr;
  const filtered = [];

  for (const filter of lSErrorTicket) {
    for (const ticket of GlobalTicketsArray) {
      if (filter.ticketId === parseInt(ticket.ticketId)) {
        const tempTasks = [];
        for (const mistake of filter.ticketErrors) {
          for (const task of ticket.tasks) {
            if (parseInt(mistake) === parseInt(task.taskId)) {
              tempTasks.push(task);
            }
          }
        }
        filtered.push({
          ...ticket,
          tasks: tempTasks.sort((a, b) => a.taskId - b.taskId),
        });
      }
    }
  }

  return filtered.sort((a, b) => a.ticketId - b.ticketId);
}

function getFromLocalStorageTickets(key) {
  const storedData = JSON.parse(localStorage.getItem(key));
  if (!storedData) return null;

  const now = new Date().getTime();
  const isDataValid = now - storedData.timestamp < CHACHE_TIME; 

  if (isDataValid) return storedData.data;
  return null;
}

function getFromLocalStorageVersion(key) {
  const storedData = localStorage.getItem(key);
  if (!storedData) return null;
  else return JSON.parse(storedData);
}

function saveToLocalStorage(key, data) {
  const timestampedData = {
    timestamp: new Date().getTime(),
    data,
  };
  localStorage.setItem(key, JSON.stringify(timestampedData));
}

async function loadTicketsArray(categoryTickets) {

  const lastTwoChars = categoryTickets.slice(
    categoryTickets.length - 2,
    categoryTickets.length
  );

  const localStorageTickets = getFromLocalStorageTickets(lastTwoChars);

  if (localStorageTickets) {
    if (categoryTickets === "errorsAB" || categoryTickets === "errorsCD") {
      return loadErrorsTickets(categoryTickets, localStorageTickets);
    }
    return localStorageTickets;
  }

  const storedVersion = getFromLocalStorageVersion(`${lastTwoChars}_version`);
  let ticketsArray;

  try {
    const versionResponse = await axios.get(`/api/tickets/version/${lastTwoChars}`);
    const currentVersion = versionResponse.data;
    const localStorageTicketsWithoutCache = JSON.parse(localStorage.getItem(lastTwoChars));

    if (storedVersion === currentVersion && localStorageTicketsWithoutCache.data) {
      saveToLocalStorage(lastTwoChars, localStorageTicketsWithoutCache.data);
      if (categoryTickets === "errorsAB" || categoryTickets === "errorsCD") {
        return loadErrorsTickets(categoryTickets, localStorageTicketsWithoutCache.data);
      }
      return localStorageTicketsWithoutCache.data;
    }

    const response = await axios.get(`/api/tickets/${lastTwoChars}`);
    ticketsArray = response.data;

    saveToLocalStorage(lastTwoChars, ticketsArray);
    localStorage.setItem(`${lastTwoChars}_version`, currentVersion);

  } catch (error) {
    throw new Error(error);
  }

  if (categoryTickets === "errorsAB" || categoryTickets === "errorsCD") {
    return loadErrorsTickets(categoryTickets, ticketsArray);
  }

  return ticketsArray;
}

export default loadTicketsArray;


/* async function loadTicketsArray(categoryTickets) {

  const lastTwoChars = categoryTickets.slice(
    categoryTickets.length - 2,
    categoryTickets.length
  );

  const localStorageTickets = getFromLocalStorage(lastTwoChars);
  if (localStorageTickets) {
    if (categoryTickets === "errorsAB" || categoryTickets === "errorsCD") {
      return loadErrorsTickets(categoryTickets, localStorageTickets);
    }
    return localStorageTickets;
  }

  let ticketsArray;

  try {
    const response = await axios.get(`/api/tickets/${lastTwoChars}`);
    ticketsArray = response.data;

    saveToLocalStorage(lastTwoChars, ticketsArray);

  } catch (error) {
    throw new Error(error);
  }

  if (categoryTickets === "errorsAB" || categoryTickets === "errorsCD") {
    return loadErrorsTickets(categoryTickets, ticketsArray);
  }

  return ticketsArray;
} */


/* import TICKETS from "../ticketsArray";
import TICKETS_CD from "../ticketsArray_cd"; 

 function loadTicketsArray(categoryTickets) {
  switch (categoryTickets) {
    case "ticketsAB":
      return TICKETS;
    case "themeAB":
      return TICKETS;
    case "newAB":
      return TICKETS;
    case "newCD":
      return TICKETS_CD;
    case "ticketsCD":
      return TICKETS_CD;
    case "themeCD":
      return TICKETS_CD;
    case "examAB":
      return TICKETS;
    case "examCD":
      return TICKETS_CD;
    case "errorsAB":
      return loadErrorsTickets(categoryTickets);
    case "errorsCD":
      return loadErrorsTickets(categoryTickets);
    default:
      console.log("ticketsArray is empty");
      break;
  }
}

export default loadTicketsArray; */